module.exports = "https://cdn.realtymogul.com/static/media/Img_card_1031.8a04fc6b.jpg";